import ScoringResultsReportForm from './ScoringResultsReportForm';

export default ScoringResultsReportForm;


// WEBPACK FOOTER //
// ./src/features/reports/pages/scoring-results-report-page/scoring-results-form/index.js